export enum Steps {
  Welcome,
  CreateTeam,
  Terminology,
  Pricing,
  Consent,
}
